import {ReportedError, ErrorCatalogId} from "../Types.ts";
import jsonApi from "./jsonApi.ts";

export async function listInCatalog(catalogId: ErrorCatalogId) {
  return await jsonApi.get<ReportedError[]>(`/reported_error_catalogs/${catalogId}/errors`);
}
